import {Component, HostListener, Injector, ChangeDetectionStrategy} from '@angular/core';
import { AppSettings, Settings } from './app.settings';
import { Subject } from 'rxjs';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart, Params,
  Router,
} from '@angular/router';
import { LoadingService } from './core/services/loading.service';
import { CookieService } from 'ngx-cookie-service';
import {TranslateService} from "@ngx-translate/core";
import {AuthService} from "./core/services/auth.service";
import {getSessionLang, SUPPORTED_LANGS} from "./core/utils/locale-url";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
  title = `New PTM`;
  public settings: Settings;

  isIframe: boolean;
  loginDisplay: boolean;
  isLoading: Subject<boolean> = this.loadingService.isLoading;
  public showBackToTop = false;

  constructor(
    private loadingService: LoadingService,
		private authService: AuthService,
    private router: Router,
    private appSettings: AppSettings,
    private activatedRoute: ActivatedRoute,
    private cookieService: CookieService,
    private translate: TranslateService
  ) {
    this.isIframe = window !== window.parent && !window.opener;
    this.settings = this.appSettings.settings;

    this.router.events.subscribe((event: Event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.loadingService.show();
          break;
        }

        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          this.loadingService.hide();
          break;
        }
        default: {
          break;
        }
      }
    });

    // Language: from a locale link (/en/..., /fr/...) for this session, otherwise the browser's
    this.translate.addLangs(SUPPORTED_LANGS);
    const browserLang = navigator.language.split('-')[0];
    const lang = getSessionLang() ?? browserLang;
    this.translate.use(this.translate.getLangs().includes(lang) ? lang : 'en');
  }

  private getActivatedComponent(snapshot: ActivatedRouteSnapshot): any {
    if (snapshot.firstChild) {
      return this.getActivatedComponent(snapshot.firstChild);
    }
    return snapshot.component;
  }

  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener;
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params && params['initializeProcess']) {
        const initializeProcess = JSON.parse(params['initializeProcess']);
        if (initializeProcess) {
          this.authService.logout();
        }
      }
    });
  }

  ngOnDestroy() {}

  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event: any) {
    $event.target.documentElement.scrollTop > 100
      ? (this.showBackToTop = true)
      : (this.showBackToTop = false);
  }

  public goToTop() {
    const elmnt = document.getElementById('top');
    elmnt.scrollIntoView({ behavior: 'smooth' });
  }
}
